import { render, staticRenderFns } from "./ColorSwatchSVG.vue?vue&type=template&id=6302f79d&scoped=true&"
import script from "./ColorSwatchSVG.vue?vue&type=script&lang=js&"
export * from "./ColorSwatchSVG.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwatchSVG.vue?vue&type=style&index=0&id=6302f79d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6302f79d",
  null
  
)

export default component.exports